import React from "react";
import styles from "../styles/ip-info.module.scss";

const IPInfo = ({ show }) => {
  const [state, setState] = React.useState({
    ip: "0.0.0.0",
    city: "",
    region: "",
    isp: "",
    loading: true,
  });
  const fetchIpInfo = React.useCallback(async () => {
    fetch("https://ipinfo.io/?token=8fe444d62bf054")
      .then((response) => response.json())
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          ip: data.ip,
          city: data.city,
          region: data.region,
          isp: data.org,
        }));
      })
      .catch(() => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
      });
  }, []);
  React.useEffect(() => {
    fetchIpInfo();
  }, [fetchIpInfo]);

  if (show) {
    return (
      <div className={styles.root}>
        {state.loading ? (
          <span>Loading...</span>
        ) : (
          <>
            <span>Your IP: {state.ip}</span>
            <span>
              Location: {state.city}, {state.region}
            </span>
            <span>ISP: {state.isp}</span>
          </>
        )}
      </div>
    );
  }
  return null;
};

export default IPInfo;
